import React from "react";

function FooterContact() {
  return (
    <div className="col-md-6 mb-5">
      <h5 className="text-primary text-uppercase mb-4" style={{ letterSpacing: "5px" }}>Contáctenos</h5>
      <p><i className="fa fa-map-marker-alt mr-2"></i>Sede administrativa Medellin, Colombia</p>
      <a href="https://wa.me/573028688273"><p><i className="fa fa-phone-alt mr-2"></i>+57 302 8688273</p></a>
      <p><i className="fa fa-envelope mr-2"></i>info@disempacademy.com</p>
      <div className="button-reds-footer mt-4">
        <a className="btn btn-outline-light btn-square mr-2" href="https://www.facebook.com/profile.php?id=61567435371918"><i className="fab fa-facebook-f" alt="Pagina Facebook"></i></a>
        <a className="btn btn-outline-light btn-square" href="https://www.instagram.com/dissemp.ac/"><i className="fab fa-instagram" alt="Pagina Instagram"></i></a>
      </div>
    </div>
  );
}

export default FooterContact;